import i18n from "i18next";
import { initReactI18next, setDefaults } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Hier definierst du deine Übersetzungen direkt strukturiert
const resources = {
  de: {
    translation: {
	  common: {
        save: "Speichern",
        cancel: "Abbrechen",
		edit: "Bearbeiten",
		add: "Hinzufügen",
        online_query: "Online Abfrage",
        overwrite_title: "Daten überschreiben?",
        no_external_data: "Keine externen Abgleichdaten ausgewählt.",
		no_option: "Keine Auswahl",
		no_values: "Keine Werte vorhanden",
		overwrite_values: "Werte überschreiben",
		not_defined: "nicht hinterlegt",
		search_musicbrainz: "Suche bei MusicBrainz",
		search_itunes: "Suche bei iTunes",
		search_results: "Gefundene Treffer (Bitte wählen)",
		from: "Von",
		old_value: "Alt",
		new_value: "Neu",
		composer: "Interpret",
		sheet: "Notenblatt",
		composers: "Interpreten",
		sheets: "Musiknoten",	
		song_title: "Titel",
		optional: "optional",
		asc: "Aufsteigend",
		desc: "Absteigend",
		all: "Alle",
		entry: "Eintrag",
		entries: "Einträge",
		column: "Spalten",
		row: "Zeilen",
		view_mode_gallery: "Galerie",
		view_mode_list: "Tabelle",
		pageCount: "{{startCnt}} von {{endCnt}}",
		updatedAt: "Zuletzt geändert",
		langOptionDe: "Deutsch",
		langOptionEn: "Englisch",
	  },
	  files: {
		preview_url: "Bild-Vorschau URL",
		preview_file: "Bild-Vorschau Datei",
		no_image: "kein Bild vorhanden",
		live_preview: "Live-Vorschau",
		upload_url: "von URL hochladen",
		upload_file: "von Filesystem hochladen",
		select_image: "Bild auswählen",
		url_to_image: "URL zum Bild",
		file_to_image: 'Datei hierher ziehen oder <span class="filepond--label-action">Durchsuchen</span>',
		file: "Datei",
		preview: "Voransicht",
		thumbnail: "Vorschaubild",
		check_preview: "Prüfe Bild",		
      },
	  user: {
		email: "EMail",
		password: "Passwort",
		role: "Rolle",
		language: "Sprache",
		givenname: "Vorname",
		lastname: "Nachname",
		username: "Benutzername",
		phone: "Telefon",
		role_user: "Anwender",
		role_admin: "Admin",
		role_unknown: "Unbekannt",
		activity: "Kontostatus",
		is_active_true: "Aktiviert (Zugriff erlaubt)",
		is_active_false: "Deaktiviert (Zugriff gesperrt)",		
	  },
	  sheet: {
		title: "Titel",
		releaseDate: "Veröffentlichung", 
		collection: "Album",
		informationText: "Beschreibung",
		keySignature: "Tonart",
		tempo: "Tempo (BPM)",
		duration: "Dauer (mm:ss)",
		instrument: "Instrument",
		youtubeLink: "Link zu YouTube",
		tags: "Tags",
		placeholder_tags: "z.B. Romantik, Schwer, Ballade",
		categories: "Setlisten",
		placeholder_categories: "z.B. Weihnachten, Gartenfest, Kirmes",
		category: "Kategorie / Genre",    
		mbId: "",  
		ratingAvg: "Rating",	
	  },		  
      composer: {
		epoch: "Epoche",
        disambiguation: "Erläuterung",
        area: "Wirkungsort",
        countryCode: "Ländercode",
        artistId: "Künstler-ID bei MusicBrainz",
        imdbUrl: "Link zu IMDb",
        gender: "Gender",
        type: "Art des Interpreten",
        lifespanBegin: "Karriere Beginn (Datum)",
        lifespanEnd: "Karriere Ende (Datum)",
        lifespanIsEnded: "Karriere beendet / verstorben / aufgelöst",
      },
	  PageSideBar: {
		MdlSidebarOverlayTitle: "Musiknoten-Upload",
		login: "Login",
		search: "Suche",
		settings: "Einstellungen",
		profile: "Mein Profil",
		sheets: "Musiknoten",
		sync: "Reload",
		upload: "Musiknoten-Upload",		
      },
	  PageSettings: {
		pageTitle: "Einstellungen",
		statusMsg_no_admin: "Die Administration ist nur für Admins verfügbar!",
		typeOfSetting_songtype: "Musikstil",
		typeOfSetting_artisttype: "Interpreten-Typ",
		typeOfSetting_gender: "Gender",
		typeOfSetting_classification: "Klassifizierung",
		typeOfSetting_instrument: "Instrument",		 
      },
	  SettingUserMgntCard: {
		pageTitle: "Benutzerkonten verwalten",
		edit_user: "Benutzer ändern",
		create_user: "Neuen Benutzer anlegen",
		missing_user: "Kein Benutzer",
		load_users: "Lade Benutzerliste",
		delete_user: "Möchten Sie diesen Benutzer wirklich unwiderruflich löschen?",
      },
	  SettingTypesMgntCard: {
		pageTitle: "{{value}} bearbeiten",
		editMode: "(Bearbeitungsmodus)",
		key: "Schlüssel / Key",
		value: "Anzeigewert / Value)",
		missing_key: "Kein Key",
		statusMsg_missing_keyvalue: "Bitte Key und Wert ausfüllen!",
		statusMsg_edit_cat: "Kategorie erfolgreich aktualisiert",
		statusMsg_add_cat: "Kategorie erfolgreich hinzugefügt",
		statusMsg_error_edit: "Fehler beim Aktualisieren!",
		statusMsg_error_add: "Fehler beim Speichern!",
		statusMsg_error_delete: "Fehler beim Löschen!",
      },
	  PageSheets: {
		no_sheets_found: "Keine Musiknoten gefunden",

      },
	  PageProfile: {
		pageTitle: "Benutzerprofil",
		pageDescription: "Verwalten Sie Ihre Kontodetails und Sicherheit",
		statusMsg_edit_success: "Profil und Passwort erfolgreich aktualisiert",
		statusMsg_edit_error: "Speichern von Profil und Passwort ist fehlgeschlagen!",
		statusMsg_confirmPassword: "Die Passwörter stimmen nicht überein!",
	  	subtitle_section_1: "Benutzer",
		subtitle_section_2: "Profilinformationen",
		subtitle_section_3: "Passwort setzen",
		password_new: "Neues Passwort setzen (optional)",
		password_confirm: "Neues Passwort bestätigen",
		placeholder_password: "Leer lassen für keine Änderung",

      },
	  PageSheetsPage: {
		pageTitle: "Musiknoten-Bibliothek",
		placeholder_search: "Musiknoten, Interpreten, Genres...",
		loading_page: "Lade Musiknoten-Bibliothek.....",
      },
	  PageComposersPage: {
		pageTitle: "Interpreten-Bibliothek",
		placeholder_search:  "Interpreten, Epoche...",
		loading_page: "Lade Interpreten-Bibliothek.....",
	  },
	  PageHomePage: {
		pageTitle: "Home",
		new_sheets: "Neue Musiknoten",
		new_composer: "Neue Interpreten",
	  },
	  MdlSidebarSheetUpload: {
	  	subtitle_section_1: "Stammdaten",
		subtitle_section_2: "Musikalische Details",
		subtitle_section_3: "Zusatzmedien & Beschreibung",
      },
	  MdlComposerEdit: {
		subtitel_section_3: "Manuelle Korrekturen",
      },
	  MdlSettingEditAccount: {
		statusMsg_sendEditRequest: "Fehler beim Aktualisieren des Benutzers!",
	  	subtitle_section_1: "Passwort setzen",
		subtitle_section_2: "Profilinformationen",
		subtitle_section_3: "Status & Rechte",
		password_new: "Neues Passwort setzen (optional)",
		password_confirm: "Neues Passwort bestätigen",
		placeholder_password: "Leer lassen für keine Änderung",		
      },
	  MdlSettingCreateAccount: {
	  	subtitle_section_1: "Benutzer-Anmeldedaten",
		subtitle_section_2: "Profilinformationen",
		subtitle_section_3: "Status & Rechte",
		password_confirm: "Neues Passwort bestätigen",
		statusMsg_confirmPassword: "Die Passwörter stimmen nicht überein!",
		statusMsg_sendCreateRequest: "Fehler bei der Neuanlage des Benutzers!",

      },
    }
  },
  en: {
    translation: {
	  common: {
        save: "Save",
        cancel: "Cancel",
		edit: "Edit",
		add: "Add",
        online_query: "Online Query",
        overwrite_title: "Daten überschreiben?",
        no_external_data: "Keine externen Abgleichdaten ausgewählt.",
		no_option: "no option",
		no_values: "no values vorhanden",
		overwrite_values: "values überschreiben",
		not_defined: "nicht hinterlegt",
		search_musicbrainz: "Suche bei MusicBrainz",
		search_itunes: "Suche bei iTunes",
		search_results: "Gefundene Treffer (Bitte wählen)",
		from: "Von",
		old_value: "Old",
		new_value: "New",
		composer: "Artist",
		sheet: "Sheet",
		composers: "Artists",
		sheets: "Sheets",	
		song_title: "Title",
		optional: "optional",
		asc: "ascending",
		desc: "descending",
		all: "All",
		entry: "entry",
		entries: "entries",
		column: "column",
		row: "row",
		view_mode_gallery: "Gallery",
		view_mode_list: "List",
		pageCount: "{{startCnt}} from {{endCnt}}",
		updatedAt: "Last update",
	  },
	  files: {
		preview_url: "Bild-Vorschau URL",
		preview_file: "Bild-Vorschau Datei",
		no_image: "no image",
		live_preview: "Live-Vorschau",
		upload_url: "Upload from URL",
		upload_file: "Upload from filesystem",
		select_image: "Select image",
		url_to_image: "URL to image",
		file_to_image: 'drag and drop here <span class="filepond--label-action">or open dialog</span>',
		file: "File",
		preview: "Image",
		check_preview: "check image",		
      },
	  user: {
		email: "EMail",
		role: "Role",
		language: "Language",
		role_user: "User",
		role_admin: "Admin",
	  },
	  sheet: {
		title: "Titel",
		releaseDate: "Veröffentlichung", 
		collection: "Album",
		informationText: "Beschreibung",
		keySignature: "Tonart",
		tempo: "Tempo (BPM)",
		duration: "Dauer (mm:ss)",
		instrument: "Instrument",
		youtubeLink: "Link zu YouTube",
		tags: "Tags",
		placeholder_tags: "z.B. Romantik, Schwer, Ballade",
		categories: "Setlisten",
		placeholder_categories: "z.B. Weihnachten, Gartenfest, Kirmes",
		category: "Kategorie / Genre",    
		mbId: "",  
		ratingAvg: "Rating",	
	  },		  
      composer: {
		epoch: "Epoche",
        disambiguation: "Erläuterung",
        area: "Wirkungsort",
        countryCode: "Ländercode",
        artistId: "MusicBrainz-ID",
        imdbUrl: "Link zu IMDb",
        gender: "Gender",
        type: "Art des Interpreten",
        lifespanBegin: "Karriere Beginn (Datum)",
        lifespanEnd: "Karriere Ende (Datum)",
        lifespanIsEnded: "Karriere beendet / verstorben / aufgelöst",
      },
	  SettingUserMgntCard: {
		pageTitle: "Benutzerkonten verwalten",
		edit_user: "Edit Account",
		create_user: "Create new Account",
		missing_user: "No Account",
		load_users: "Load Accounts",
		delete_user: "Möchten Sie diesen Benutzer wirklich unwiderruflich löschen?",
      },
	  SettingTypesMgntCard: {
		pageTitle: "Edit {{value}}",
		editMode: "(Edit-Mode)",
		key: "Key",
		value: "Value)",
		missing_key: "No Key",
		statusMsg_missing_keyvalue: "Bitte Key und Wert ausfüllen!",
		statusMsg_edit_cat: "Kategorie erfolgreich aktualisiert",
		statusMsg_add_cat: "Kategorie erfolgreich hinzugefügt",
		statusMsg_error_edit: "Fehler beim Aktualisieren!",
		statusMsg_error_add: "Fehler beim Speichern!",
		statusMsg_error_delete: "Fehler beim Löschen!",
      },
	  PageSideBar: {
		MdlSidebarOverlayTitle: "Sheet-Upload",
		login: "Login",
		search: "Search",
		settings: "Settings",
		profile: "My Profil",
		sheets: "Sheets",
		sync: "Reload",
		upload: "Sheet-Upload",		
      },
	  PageSettings: {
		pageTitle: "Settings",
		statusMsg_no_admin: "Die Administration ist nur für Admins verfügbar!",
		typeOfSetting_songtype: "Songtype",
		typeOfSetting_artisttype: "Artists-Typ",
		typeOfSetting_gender: "Gender",
		typeOfSetting_classification: "Classification",
		typeOfSetting_instrument: "Instrument",		 
      },
	  PageSheetsPage: {
		pageTitle: "Sheets-Library",
		placeholder_search: "Sheets, Collections, Genres...",
		loading_page: "Load Sheets-Library.....",
      },
	  PageComposersPage: {
		pageTitle: "Artists-Library",
		placeholder_search:  "Artists, Epoch...",
		loading_page: "Load Artists-Library.....",
	  },
	  MdlSidebarSheetUpload: {
	  	subtitle_section_1: "Main-Data",
		subtitle_section_2: "Musical Details",
		subtitle_section_3: "AddOn´s & Description",
      },
	  MdlComposerEdit: {
		subtitel_section_3: "Manuel Editing",
      },
	}
  }
};

i18n
  .use(LanguageDetector) // Erkennt automatisch die Browsersprache
  .use(initReactI18next)  // Bindet i18n an react-i18next an
  .init({
    resources,
    fallbackLng: "de",    // Standardsprache, falls Erkennung fehlschlägt
    interpolation: {
      escapeValue: false  // React schützt bereits vor XSS
    },
    detection: {
      order: ["localStorage", "navigator"], // Sucht zuerst im Speicher, dann im Browser
      caches: ["localStorage"]              // Speichert die Wahl des Users im LocalStorage
    }
  });

if (setDefaults) {
  setDefaults(i18n);
}

export default i18n;